@if (isLayoutReady) {
  <ckeditor
    [data]="data"
    [editor]="editor"
    [config]="editorConfig"
    (ready)="onEditorReady($event)"
    [formControl]="formControlEditing"
  ></ckeditor>
}
